import { Component, OnInit, NgZone } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { OktaService } from '../../core/security/services/okta.service';
import { AuthenticationService } from '../../core/security/services/index';
import { AuthEventService } from '../../core/security/services/auth.events.service';
import { ApiService } from '../../shared/api/api.service';
import { ConfigService } from '../../core/config/config.service';

@Component({
    selector: 'mc-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    loginWidget;
    isAuthenticated = false;

    constructor(private authService: AuthenticationService,
        private authEventService: AuthEventService,
        private _ngZone: NgZone,
        private router: Router,
        private api: ApiService,
        private config: ConfigService) {
        // Replace with state
        this.authService.getSessionChanges().subscribe((identitySession) => {
            this._ngZone.run(() => {
                this.isAuthenticated = identitySession !== null;
            });
        });
    }

    ngOnInit() {
        this.loginWidget = this.authService.getLoginWidget();
        this.authService.isAuthenticated().subscribe((authenticated) => {
            if (!authenticated) {
                setTimeout(() => { this.showLogin(); }, 100);
            }
        });
    }

    showLogin() {
        this.loginWidget.remove();
        this.loginWidget.renderEl({ el: '#login-container' }, (response) => {

            if (response.status === 'SUCCESS') {
                this._ngZone.run(() => {
                    let idToken = null;
                    let accessToken = null;

                    if (response instanceof Array) {
                        // If the widget is configured for OIDC with multiple responseTypes, the
                        // response will be an array of tokens
                        idToken = response[0];
                        accessToken = response[1];
                    } else {
                        // If the widget is configured for OIDC with a single responseType
                        idToken = response;
                    }

                    this.authService.authenticate(idToken, accessToken).subscribe(() => {
                        this.api.post(this.config.const.apiMethods.mcApi.authentication.addUser, null).subscribe(() => this.redirect());
                    });
                });
            }
        });
    }

    logout() {
        this.authService.logOut().subscribe((authenticated) => {
            location.reload();
        });
    }

    redirect() {
        const redirect = this.authService.redirectUrl ? this.authService.redirectUrl : '/labs';

        const navigationExtras: NavigationExtras = {
            preserveQueryParams: true,
            preserveFragment: true
        };

        this.authService.redirectUrl = '';
        this.router.navigate([redirect], navigationExtras);
    }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/public/login/login.component.ts